import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function getICalExportToken() {
  const res = await fetchOrchidAPI("/api/scheduler/calendar/ical/token");
  if (!res.ok) {
    throw new Error(
      `failed to get iCal token: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
